const infoIcons = {
  department: {
    title: "My Departments",
    body: "Departments are a fundamental element of XLplanner. All the most important actions in the application are performed by assigning the department to which the planned action will apply.",
    button: "Add department",
    missing: "No departments",
  },
  "outside-department": {
    title: "External Warehouses",
    body: "External warehouses can be used as unloading locations in orders. You cannot assign employees to them or fill in calendars.",
    button: "Add external warehouse",
    missing: "No external warehouses",
  },
  warehouse: {
    title: "My Warehouses",
    body: "Warehouses are a fundamental element of XLplanner. All the most important actions in the application are performed by assigning the warehouse to which the planned action will apply.",
    button: "Add warehouse",
    missing: "No warehouses",
  },
  workers: {
    title: "Employees",
    body: "Invite employees to use the application. You can add new users by choosing one of three roles: Administrator, Manager, or Employee. Each has a different level of permissions. After sending the invitation, they will receive an email with login details (if they don’t already have an account) or will be added to your company (if they already have an XLplanner account).",
    button: "Add employee",
    for: "Show employees for",
    missing: "No employees",
  },
  drivers: {
    title: "Drivers",
    body: "Drivers are necessary to submit offers in orders. Unlike Employees, they do not have an account in the application.",
    button: "Add driver",
    for: "Show drivers for",
    missing: "No drivers",
  },
  documents: {
    title: "Documents",
    body: "Add documents so that other users can learn about your company. In addition to basic documents, you can upload any files and specify whether they should be public or visible only to your company.",
    button: "Add document",
    missing: "No documents",
  },
  cars: {
    title: "My Vehicles",
    body: "Add vehicles to participate in orders. Assign the appropriate license type to each vehicle. Set the expiration date for inspections and insurance, and we will send you reminders about upcoming deadlines.",
    button: "Add vehicle",
  },
  timeWindows: {
    title: "Time Windows",
    body: "Time windows are used to reserve time slots during scheduling.",
    button: "Buy time windows",
  },
  abonament: {
    title: "Subscription",
    body: "The subscription allows you to participate in orders.",
    button: "Buy subscription",
  },
  warehouseList: {
    title: "Warehouse List",
    body: "Here is a list of warehouses. You can find companies here that you can authorize. Before sending an authorization request, you can always review key company information and documents in its profile.",
  },
  authorizations: {
    title: "Authorizations",
    body: "Here you will find a list of all authorization requests you have sent to other companies. You can also withdraw your requests here.",
  },
  monitaryNote: {
    title: "Scheduling",
    body: "In this section, you can see all booked schedules, their statuses, and detailed information. You also have access to chat with the warehouse where you made the reservation, and you can download the transport document. Scheduling is only possible with authorized warehouses.",
    button: "Add schedule",
  },
  postedAuction: {
    title: "Order Exchange",
    body: "Here you will find available orders. After purchasing a subscription, you can submit offers to win orders.",
  },
  currentAutcions: {
    title: "Ongoing Orders",
    body: "Here you can find orders in which you are currently participating.",
  },
  assignedAuctions: {
    title: "Assigned Orders",
    body: "These are orders assigned to you after your offer has been accepted.",
  },
  assignedTransports: {
    title: "Assigned Transports",
    body: "These are orders received directly from the Carrier without the need to submit offers.",
    missing: "No transports.",
  },
  canceledTransports: {
    title: "Cancelled / Unreceived Transports",
    body: "These are received orders that were cancelled or not obtained.",
  },
  declinedTransports: {
    title: "Unreceived Transports",
    body: "These are orders your department did not receive.",
  },
  additionalPayment: {
    title: "Additional Payments for Orders",
    body: "This is a list of all additional payments attached to assigned transports.",
  },
  leasing: {
    title: "Leasing",
    body: "Submit leasing applications, which we will review. You will receive a notification with our decision.",
    button: "Submit application",
    missing: "No applications",
  },
  factoring: {
    title: "Factoring",
    body: "This is a list of all orders with approved factoring.",
    missing: "No orders with factoring",
  },
  myWarehouses: {
    title: "My Warehouses",
    body: "Warehouses are a fundamental element of XLplanner. All the most important actions in the application are performed by assigning the warehouse to which the planned action will apply.",
    button: "Add warehouse",
  },
  driversGroups: {
    title: "Driver Groups / Created Groups",
    body: "You can use driver groups when creating orders if you don’t want them to be publicly available. When adding an order, select the preferred group of recipients. Only drivers belonging to that group will be able to see the order and submit offers. You can only add authorized drivers to groups.",
    button: "Create group",
    for: "Show groups for",
    missing: "No groups for the selected department",
  },
  createCalendar: {
    title: "Create Calendar",
    body: "Fill out the calendar for a given month so that Carriers can book scheduling slots in your warehouse. After creating the calendar, you can edit any day by adding, editing, or deleting time windows.",
  },
  monitaryArchiveDriver: {
    for: "Select department",
    missing: "No archived schedules for the selected department",
  },
  monitaryArchiveWarehouse: {
    for: "Select warehouse",
    missing: "No archived schedules for the selected warehouse",
  },
  auctionsArchive: {
    missing: "No archived orders",
  },
  auctionsForProducer: {
    missing: "No orders",
  },
  authorizationsProducer: {
    title: "Authorizations",
    body: "Here you will find a list of all authorization requests. You can accept or reject them.",
  },
  monitaryNotesProducer: {
    title: "Scheduling",
    body: "In this section, you can see all reserved schedules, their status, and detailed information. You also have access to chat with the Carrier who booked a schedule in your warehouse and the option to download the transport document. Here you can also confirm whether the driver arrived on time.",
  },
  myAuctions: {
    title: "My Orders",
    body: "These are all orders created by you. You can add, edit, or cancel orders here. You also select the driver to whom you will assign the order.",
    button: "Add order",
  },
  cancelledAuctions: {
    title: "Cancelled Orders",
    body: "This is a list of all published announcements that have been cancelled.",
  },
  participants: {
    title: "List of Participants",
    body: "This is a list of all Drivers participating in the orders you created.",
    for: "Show participants for",
    missing: "No participants",
  },
  wallet: {
    button: "Recharge windows",
    buttonSub: "Buy subscription",
  },
  invoiceList: {
    missing: "No issued invoices.",
  },
  monthlyInvoices: {
    title: "Monthly Invoices",
    body: "Here you can find a summary of all payments for a given month. The summary is generated at the beginning of the following month.",
  },
};
export default infoIcons;
